import Vue from 'vue';
import Vuex from 'vuex';
import { ethers } from 'ethers';
import utils from '../utils';
import Notify from 'bnc-notify';

Vue.use(Vuex);

const blocknative = new Notify({
  dappId: '773ba398-31f9-4816-a3b3-960a075a0f31', // TODO: change prototype dapp ID
  networkId: 4
});

import EthFighterPreSale from '../truffleconf/EthFighterPreSale.json';
import EthFighterToken from '../truffleconf/EthFighterToken.json';

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export default new Vuex.Store({
  modules: {},
  state: {
    provider: null,
    signer: null,
    chain: null,
    account: null,
    ethFighterTokenContract: null,
    ethFighterPreSaleContract: null,
    characterTypeId: null
  },
  mutations: {
    web3Init(state, { provider, signer, chain, account, contracts }) {
      state.provider = provider;
      state.signer = signer;
      state.chain = chain;
      state.account = account;

      const { ethFighterTokenContract, ethFighterPreSaleContract } = contracts;
      state.ethFighterTokenContract = ethFighterTokenContract;
      state.ethFighterPreSaleContract = ethFighterPreSaleContract;
    }
  },
  actions: {
    async bootstrap({ commit }) {
      await window.ethereum.enable();

      /*global web3*/
      const provider = new ethers.providers.Web3Provider(web3.currentProvider);
      const signer = provider.getSigner();
      const chain = await provider.getNetwork();
      const accounts = await provider.listAccounts();

      const ethFighterPreSaleAddress = utils.getContractAddressFromTruffleConf(EthFighterPreSale, chain.chainId);
      const ethFighterPreSaleContract = new ethers.Contract(ethFighterPreSaleAddress, EthFighterPreSale.abi, signer);

      const ethFighterTokenAddress = utils.getContractAddressFromTruffleConf(EthFighterToken, chain.chainId);
      const ethFighterTokenContract = new ethers.Contract(ethFighterTokenAddress, EthFighterToken.abi, signer);

      commit('web3Init', {
        provider,
        signer,
        chain,
        account: accounts[0],
        contracts: {
          ethFighterPreSaleContract,
          ethFighterTokenContract
        },
      });
    },
    async buyMultipleCrates({ state }, payload) {
      const { id, quantity, price } = payload;
      const tx = await state.ethFighterPreSaleContract.buyMultipleCrates(id, quantity, ZERO_ADDRESS, {
        value: ethers.utils.parseEther((quantity * price).toString()),
        // gasLimit: quantity * 300000 // we set the gas limit higher than typically estimates due to specials often getting out of gas
      });

      blocknative.hash(tx.hash);

      return tx;
    },
    async upgradeAttributes({ state }, payload) {
      const { upgradePoints, upgradeTypeId, tokenId } = payload;

      console.log("upgradeTypeId"+upgradeTypeId);
      if (upgradeTypeId == 3) {
        console.log(upgradeTypeId);
        const tx = await state.ethFighterTokenContract.setCharacterPower(tokenId, upgradePoints);
        console.log("==>" + tx)
        return tx;
      } else if (upgradeTypeId == 4) {
        console.log(upgradeTypeId)
        const tx = await state.ethFighterTokenContract.setCharacterHealth(tokenId, upgradePoints);
        return tx;
      } else if (upgradeTypeId == 8) {
        console.log(upgradeTypeId)
        const tx = await state.ethFighterTokenContract.setCharacterSpeed(tokenId, upgradePoints);
        return tx;
      } else {
        return false;
      }

    },
    async getBalance({ state }) {
      return await state.provider.getBalance(state.account);
      // return balance;
    },
    async getCrateDetails({ state }, crateId) {
      const {
        _randomisationSource,
        _characterTypeIds,
        _totalCharacterStock,
        _cratePrice,
        _bonusCrateId
      } = await state.ethFighterPreSaleContract.getCrateConfig(crateId);
      return {
        randomisationSource: _randomisationSource,
        characterTypeIds: _characterTypeIds,
        totalCharacterStock: _totalCharacterStock,
        cratePrice: _cratePrice,
        bonusCrateId: _bonusCrateId
      };
    },
    async getCharacterMintCountAndLimits({ state }, crateId) {
      const {
        _characterTypeIds,
        _characterTypeMintCounts,
        _characterTypeMintLimits
      } = await state.ethFighterPreSaleContract.getCharacterMintCountAndLimits(crateId);

      return {
        characterTypeIds: _characterTypeIds,
        characterTypeMintCounts: _characterTypeMintCounts,
        characterTypeMintLimits: _characterTypeMintLimits
      };
    },
  },
  getters: {
    account: state => state.account,
    chain: state => state.chain,
    ethFighterPreSaleContract: state => state.ethFighterPreSaleContract,
  }
});
